<div class="container mobile-container container-space">
  <div class="box-info">
    <div class="row">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="Title-account d-flex flex-column align-items-start justify-content-start">
          <span>{{ 'IndividualProfile' | translate }}</span>
          <img class="mt-2 d-lg-block d-none"
               src="/icons/line-categories.svg">
        </div>
        <div class="btn-back d-lg-none d-block">
        <span (click)="openBackClicked()">
         {{ 'Back' | translate }}
          <img src="/icons/forward-outline.svg">
        </span>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'FirstName' | translate }}</label>
        <app-frontend-input [(value)]="firstName"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'LastName' | translate }}</label>
        <app-frontend-input [(value)]="lastName"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'Mobile' | translate }}</label>
        <app-frontend-input [(value)]="mobile"
                            [disabled]="true"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'NationalCode' | translate }}</label>
        <app-frontend-input [(value)]="nationalCode"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'Email' | translate }}</label>
        <app-frontend-input [(value)]="email"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mb-3">
        <label>{{ 'DateOfBirth' | translate }}</label>
        <app-frontend-input [(value)]="birthDate"
                            class="input-style"></app-frontend-input>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <app-frontend-button (click)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-red'"
                           [src]="'icons/edit-2.svg'"
                           [title]="'Update'"
                           class="not-padding"></app-frontend-button>
    </div>
  </div>
</div>
